/**
 * 通用翻译 - 中文
 * Common translations - Chinese
 */

export default {
  language_switch: '语言切换',
  loading: '加载中...',
  error: '错误',
  success: '成功',
  confirm: '确认',
  cancel: '取消',
  close: '关闭',
  save: '保存',
  edit: '编辑',
  delete: '删除',
  search: '搜索',
  submit: '提交',
  reset: '重置',
  back: '返回',
  next: '下一步',
  previous: '上一步',
  more: '更多',
  less: '收起',
  all: '全部',
  viewDetails: '查看详情',
  learnMore: '了解更多',
  contactUs: '联系我们',
  readMore: '阅读更多',
  download: '下载',
  comingSoon: '敬请期待',
  clickToLocate: '点击可在地图中定位',
  mapOverview: '地图总览',
  regionContactCenter: '地区服务中心',
  serviceNodes: '服务中心',
  serviceRegionsLabel: '服务地区',
  coverageCapability: '覆盖能力',
  localSupport: '本地支持',
  asiaPacificServiceNetwork: '亚太服务网络',
  clickCardToLocate: '点击右侧地区卡片，可快速定位到对应服务中心。',
  searchRegionPlaceholder: '搜索地区 / 城市 / 地址',
  zoomIn: '放大',
  zoomOut: '缩小',
  resetView: '重置',
  staticMapPreview: '静态地图展示',
  staticMapNote: '示意图用于展示服务覆盖，不依赖第三方地图服务。',
  step: '步骤',
  standardizedDeliveryPath: '标准化交付路径',
  serviceProcessIntro: '从前期需求梳理到后续持续优化，整个服务流程采用分阶段协同推进，帮助客户更直观地理解每一步的交付重点。',
  phase: '阶段',
  openChat: '打开客服',
  closeChat: '关闭客服',
  customerService: '客服',
  send: '发送',
  invalidType: '请选择类型',
  invalidRegion: '请选择服务地区',
  invalidCompanyName: '请输入公司名称',
  invalidContactName: '请输入联系人姓名',
  invalidPosition: '请输入职位',
  invalidEmail: '请输入邮箱地址',
  invalidEmailFormat: '请输入有效的邮箱地址',
  invalidPhone: '请输入电话号码',
  invalidPhoneFormat: '请输入有效的电话号码',
  invalidIndustry: '请选择行业',
  invalidCompanySize: '请选择公司规模',
  invalidServices: '请至少选择一项感兴趣的服务',
  invalidMessage: '请描述您的项目需求',
  requestFailed: '请求失败',
  badRequest: '请求参数错误',
  unauthorized: '未授权，请重新登录',
  forbidden: '没有权限访问',
  notFound: '请求的资源不存在',
  serverError: '服务器内部错误',
  badGateway: '网关错误',
  serviceUnavailable: '服务暂时不可用',
  requestFailedWithStatus: '请求失败，状态码: {status}',
  requestTimeout: '请求超时，请稍后重试',
  networkError: '网络连接失败，请检查网络',
  submitFailedRetry: '提交失败，请稍后重试',
  submitFailedCheck: '请检查填写的信息是否正确',
  submitFailedServer: '服务器暂时无法处理您的请求，请稍后重试',
  submitFailedNetwork: '网络连接失败，请检查网络后重试',
  ticketList: {
    newTicket: '新提交工单',
    unassigned: '待分配',
    progressLabel: '进度: {progress}%',
    status: {
      pending: '待处理',
      inProgress: '处理中',
      completed: '已完成'
    },
    samples: {
      networkIssue: '网络连接故障',
      softwareInstall: '软件安装问题',
      systemOptimization: '系统性能优化',
      supportA: '技术支持A',
      supportB: '技术支持B'
    }
  },
  share: '分享',
  copy: '复制',
  copied: '已复制',
  required: '必填',
  optional: '选填',
  placeholder: '请输入...'
}
